var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconVimeo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0,0,256,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45,14.3c-0.2,4.1 -3,9.6 -8.6,16.6c-5.7,7.4 -10.5,11 -14.5,11c-2.4,0 -4.5,-2.2 -6.2,-6.7c-1.1,-4.1 -2.3,-8.2 -3.4,-12.3c-1.3,-4.5 -2.6,-6.7 -4,-6.7c-0.3,0 -1.4,0.5 -3.3,1.8l-2,-2.3c2.1,-1.8 4,-3.1 6,-4.9c2.8,-2.4 4.8,-3.6 6.2,-3.7c3.3,-0.3 5.3,1.9 6,6.6c0.8,5.1 1.5,7.8 1.8,9c0.9,4.2 2,6.4 3.1,6.4c0.9,0 2.2,-1.4 4,-4.1c1.8,-2.8 2.7,-4.8 2.8,-6.3c0.3,-2.4 -0.7,-3.6 -2.8,-3.6c-1,0 -2.1,0.5 -3.2,0.9c2.1,-6.7 6.1,-10.2 11.9,-10c4.4,0.1 6.4,2.9 6.2,8.3z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVimeo);
export default __webpack_public_path__ + "static/media/iconVimeo.3c95ad2a5ab167f4a67176b0c3b50e6e.svg";
export { ForwardRef as ReactComponent };